import { render, staticRenderFns } from "./ItemizeCredit.vue?vue&type=template&id=2a5963c6&scoped=true"
import script from "./ItemizeCredit.vue?vue&type=script&lang=js"
export * from "./ItemizeCredit.vue?vue&type=script&lang=js"
import style0 from "./ItemizeCredit.vue?vue&type=style&index=0&id=2a5963c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5963c6",
  null
  
)

export default component.exports